import { Routes, Route, Navigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

// Layout Components
import Layout from './components/Layout/Layout'
import AdminLayout from './components/Admin/AdminLayout'
import ProtectedRoute from './components/Auth/ProtectedRoute'

// Pages
import Home from './pages/Home/Home'
import Universities from './pages/Universities/Universities'
import UniversityDetail from './pages/Universities/UniversityDetail'
import Courses from './pages/Courses/Courses'
import CourseDetail from './pages/Courses/CourseDetail'
import Blogs from './pages/Blogs/Blogs'
import BlogDetail from './pages/Blogs/BlogDetail'
import FAQs from './pages/FAQs/FAQs'
import Contact from './pages/Contact/Contact'
import About from './pages/About/About'
import Privacy from './pages/Legal/Privacy'
import Terms from './pages/Legal/Terms'
import Disclaimer from './pages/Disclaimer/Disclaimer'
import NotFound from './pages/NotFound/NotFound'

// Admin Pages
import AdminLogin from './pages/Admin/AdminLogin'
import AdminDashboard from './pages/Admin/AdminDashboard'
import AdminUniversities from './pages/Admin/AdminUniversities'
import AdminCourses from './pages/Admin/AdminCourses'
import AdminEnquiries from './pages/Admin/AdminEnquiries'
import AdminEnquiryQuick from './pages/Admin/AdminEnquiryQuick'
import AdminEnquiryBrochures from './pages/Admin/AdminEnquiryBrochures'
import AdminEnquiryCounselling from './pages/Admin/AdminEnquiryCounselling'
import AdminEnquiryContacts from './pages/Admin/AdminEnquiryContacts'
import AdminBanners from './pages/Admin/AdminBanners'
import AdminBlogs from './pages/Admin/AdminBlogs'
import AdminFAQs from './pages/Admin/AdminFAQs'
import AdminApprovals from './pages/Admin/AdminApprovals'
import AdminSpecializations from './pages/Admin/AdminSpecializations'
import AdminDegrees from './pages/Admin/AdminDegrees'
import AdminUsers from './pages/Admin/AdminUsers'

function App() {
    return (
        <>
            <Helmet>
                <title>Margdarshak - Your Education Guidance Partner</title>
                <meta name="description" content="Your trusted education guidance platform. Find the best online and distance learning programs from top universities." />
                <meta name="keywords" content="online education, distance learning, MBA, BCA, MCA, UGC recognized, career guidance" />
                <meta property="og:title" content="Margdarshak - Education Guidance Platform" />
                <meta property="og:description" content="Your trusted education guidance platform. Find the best online and distance learning programs from top universities." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://margdarshak.com" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Margdarshak - Education Guidance Platform" />
                <meta name="twitter:description" content="Your trusted education guidance platform. Find the best online and distance learning programs from top universities." />
                <link rel="canonical" href="https://margdarshak.com" />
            </Helmet>

            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="universities" element={<Universities />} />
                    <Route path="universities/:slug" element={<UniversityDetail />} />
                    <Route path="courses" element={<Courses />} />
                    <Route path="courses/:slug" element={<CourseDetail />} />
                    <Route path="blogs" element={<Blogs />} />
                    <Route path="blogs/:slug" element={<BlogDetail />} />
                    <Route path="faqs" element={<FAQs />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="about" element={<About />} />
                    <Route path="privacy" element={<Privacy />} />
                    <Route path="terms" element={<Terms />} />
                    <Route path="disclaimer" element={<Disclaimer />} />
                </Route>

                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={
                    <ProtectedRoute>
                        <AdminLayout />
                    </ProtectedRoute>
                }>
                    <Route index element={<Navigate to="/admin/dashboard" replace />} />
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="universities" element={<AdminUniversities />} />
                    <Route path="courses" element={<AdminCourses />} />
                    <Route path="enquiries/quick" element={<AdminEnquiryQuick />} />
                    <Route path="enquiries/brochures" element={<AdminEnquiryBrochures />} />
                    <Route path="enquiries/counselling" element={<AdminEnquiryCounselling />} />
                    <Route path="enquiries/contacts" element={<AdminEnquiryContacts />} />
                    <Route path="banners" element={<AdminBanners />} />
                    <Route path="blogs" element={<AdminBlogs />} />
                    <Route path="faqs" element={<AdminFAQs />} />
                    <Route path="approvals" element={<AdminApprovals />} />
                    <Route path="specializations" element={<AdminSpecializations />} />
                    <Route path="degrees" element={<AdminDegrees />} />
                    <Route path="users" element={<AdminUsers />} />
                </Route>

                {/* 404 Route */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    )
}

export default App
